import React, {lazy, Suspense} from 'react';
import {useRoutes} from 'react-router-dom';

const RouteHandlerConnector = lazy(
  () => import('./RouteHandlerConnector'),
  'RouteHandlerConnector'
);

import './GlobalRoutes.scss';

const GlobalRoutes = () => {
  const router = useRoutes([
    {
      path: '/',
      element: (
        <Suspense fallback={<div />}>
          <RouteHandlerConnector handlerName="homeHandler" />
        </Suspense>
      )
    },
    {
      path: 'changeProduct',
      element: (
        <Suspense fallback={<div />}>
          <RouteHandlerConnector handlerName="changeProductHandler" />
        </Suspense>
      )
    },
    {
      path: 'changeIncompatibleProduct',
      element: (
        <Suspense fallback={<div />}>
          <RouteHandlerConnector handlerName="selectIncompatibleProductHandler" />
        </Suspense>
      )
    },
    {
      path: 'creativeServices',
      element: (
        <Suspense fallback={<div />}>
          <RouteHandlerConnector handlerName="creativeServicesHandler" />
        </Suspense>
      )
    },
    {
      path: 'fundraising',
      element: (
        <Suspense fallback={<div />}>
          <RouteHandlerConnector handlerName="fundraisingHandler" />
        </Suspense>
      )
    }
  ]);

  return <div className="global-routes">{router}</div>;
};

GlobalRoutes.displayName = 'GlobalRoutes';

export default GlobalRoutes;
